<div class="role-types-management">
  <div class="header">
    <h2>Role Type Management</h2>
    <button class="btn btn-primary" (click)="openCreateModal()">➕ Add New Role Type</button>
  </div>

  <!-- Filter bar -->
  <div class="filters">
    <div class="filter-group">
      <label for="dbFilter">Filter by Database</label>
      <select id="dbFilter" [(ngModel)]="filterDatabase" (change)="onFilterChange()">
        <option value="">All Databases</option>
        <option *ngFor="let db of trackedDatabases" [value]="db">{{ db }}</option>
      </select>
    </div>
  </div>

  <div *ngIf="error" class="error-message">{{ error }}</div>
  <div *ngIf="loading" class="loading">Loading...</div>

  <table *ngIf="!loading && roleTypes.length > 0" class="role-types-table">
    <thead>
      <tr>
        <th>ID</th>
        <th>Role Type Name</th>
        <th>Database</th>
        <th>Description</th>
        <th>Created Date</th>
        <th>Status</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let roleType of roleTypes">
        <td>{{ roleType.roleTypeID }}</td>
        <td>{{ roleType.roleTypeName }}</td>
        <td>
          <span *ngIf="roleType.databaseName" class="db-badge">{{ roleType.databaseName }}</span>
          <span *ngIf="!roleType.databaseName" class="text-muted">—</span>
        </td>
        <td>{{ roleType.description || '-' }}</td>
        <td>{{ roleType.createdDate | date:'short' }}</td>
        <td>
          <span class="status-badge" [class.active]="roleType.isActive">
            {{ roleType.isActive ? 'Active' : 'Inactive' }}
          </span>
        </td>
        <td class="actions">
          <button class="btn btn-sm" (click)="openEditModal(roleType)">✏️</button>
          <button class="btn btn-sm" (click)="deleteRoleType(roleType)">🗑️</button>
          <button class="btn btn-sm" title="Request Artifact" (click)="openRequestModal(roleType)">📦</button>
        </td>
      </tr>
    </tbody>
  </table>

  <div *ngIf="!loading && roleTypes.length === 0" class="empty-state">
    No role types found{{ filterDatabase ? ' for database "' + filterDatabase + '"' : '' }}.
  </div>

  <!-- Request Artifact Modal -->
  <div class="modal" *ngIf="showRequestModal" (click)="closeRequestModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Request Artifact — {{ requestingRoleType?.roleTypeName }}</h3>
        <button class="close-btn" (click)="closeRequestModal()">✖</button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label>Description (optional)</label>
          <textarea [(ngModel)]="requestDescription" placeholder="Enter notes for this request" rows="3"></textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="closeRequestModal()">Cancel</button>
        <button class="btn btn-primary" (click)="submitRequest()">Submit Request</button>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div class="modal" *ngIf="showModal" (click)="closeModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>{{ isEditMode ? 'Edit Role Type' : 'Add New Role Type' }}</h3>
        <button class="close-btn" (click)="closeModal()">✖</button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label>Role Type Name *</label>
          <input type="text" [(ngModel)]="currentRoleType.roleTypeName" placeholder="e.g., DB, WEB, APP" required />
        </div>
        <div class="form-group">
          <label>Database *</label>
          <select [(ngModel)]="currentRoleType.databaseName" required>
            <option [ngValue]="undefined">— Select tracked database —</option>
            <option *ngFor="let db of trackedDatabases" [value]="db">{{ db }}</option>
          </select>
          <small class="form-hint" *ngIf="trackedDatabases.length === 0">
            No tracked databases found. Initialize database tracking first.
          </small>
        </div>
        <div class="form-group">
          <label>Description</label>
          <textarea [(ngModel)]="currentRoleType.description" placeholder="Enter description" rows="3"></textarea>
        </div>
        <div class="form-group checkbox-group">
          <label>
            <input type="checkbox" [(ngModel)]="currentRoleType.isActive" />
            Active
          </label>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="closeModal()">Cancel</button>
        <button class="btn btn-primary" (click)="saveRoleType()">
          {{ isEditMode ? 'Update' : 'Create' }}
        </button>
      </div>
    </div>
  </div>
</div>
